import { render, staticRenderFns } from "./CalendarCardItemFile.vue?vue&type=template&id=d85f6508&scoped=true"
import script from "./CalendarCardItemFile.vue?vue&type=script&lang=js"
export * from "./CalendarCardItemFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85f6508",
  null
  
)

export default component.exports